import { useCallback, useState } from 'react';
import { authRepository } from '../infrastructure/auth.repository';
import { apiErrorMessage } from './apiError';

// C-1 (preservado as-is): textos hardcodeados en español, no i18n — mismos mensajes exactos que
// ForgotPasswordPage.jsx legado. Ver nota de ambigüedad en tasks.md: el mapeo texto fijo vive
// aquí (application/) para que presentation/ solo lea un string ya resuelto (regla #3).
const EMAIL_REQUIRED_MESSAGE = 'El correo electrónico es requerido.';
const GENERIC_ERROR_MESSAGE = 'Error al procesar la solicitud.';

/** UC-2: validación local del email + POST /auth/forgot-password + estado de éxito. */
export function useForgotPassword() {
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = useCallback(async (email: string): Promise<void> => {
    if (!email.trim()) {
      setError(EMAIL_REQUIRED_MESSAGE);
      return;
    }
    setLoading(true);
    setError('');
    try {
      await authRepository.forgotPassword(email.trim());
      setSuccess(true);
    } catch (err: unknown) {
      setError(apiErrorMessage(err) || GENERIC_ERROR_MESSAGE);
    } finally {
      setLoading(false);
    }
  }, []);

  return { error, success, loading, submit };
}
